import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export const state = {
  loaded: false,
  filters: [],
  buildingtype: [],
  materials: [],
  reporttype: [],
  results: {
    info: "detailed",
    term: "",
    currentPage: 1,
    endPage: 1,
    sizeValue: 20,
    fromValue: 0,
    totalPages: 1,
    results: [],
    suggestions: {},
    suggestionTrigger: false,
    totals: 0,
    searched: false
  }
};

export const mutations = {
  REPLACE_QUERYDATA(state, data) {
    state.results.term = data[0].term;
    state.results.searched = data[0].searched;
    state.results.results = data[0].results;
    state.results.totals = data[0].totals;
    state.results.startResults = data[0].startResults;
    state.results.fromValue = data[0].fromValue;
    state.results.sizeValue = data[0].sizeValue;
    state.results.totalPages = data[0].totalPages;
    state.results.endPage = data[0].endPage;
    return state;
  },
  SET_LOADED(state, loaded) {
    state.loaded = loaded || false;
  },
  SET_CHECKED(state, data) {
    switch (data.model) {
      case "buildingtype":
        state.buildingtype = data.value;
        break;
      case "materials":
        state.materials = data.value;
        break;
      case "reporttype":
        state.reporttype = data.value;
        break;
      default:
        break;
    }
  },
  SORT(state, data) {
    let sortKey = data;
    return state.results.results.sort(function(a, b) {
      if (sortKey === "architect") {
        let splitA = a._source[sortKey].trim().split(" ");
        let splitB = b._source[sortKey].trim().split(" ");
        if (splitA[splitA.length - 1] < splitB[splitB.length - 1]) return -1;
        if (splitA[splitA.length - 1] > splitB[splitB.length - 1]) return 1;
      } else {
        if (a._source[sortKey] < b._source[sortKey]) return -1;
        if (a._source[sortKey] > b._source[sortKey]) return 1;
      }
      return 0;
    });
  }
};

export const actions = {
  LOAD_QUERYDATA(context, payload) {
    context.commit("REPLACE_QUERYDATA", payload);
    context.commit("SET_LOADED", true);
  },
  GET_CHECKED(context, payload) {
    context.commit("SET_CHECKED", payload);
  },
  SORT_BY(context, payload) {
    context.commit("SORT", payload);
  }
};

export default new Vuex.Store({
  state,
  mutations,
  actions
});
